import React, { RefObject } from 'react';

import MCardView from './MCard.view';

interface Props {
  className?: string;
  containerRef?: RefObject<HTMLDivElement> | null;
}

const MCard: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return <MCardView containerRef={props.containerRef} className={props.className}>{props.children}</MCardView>;
};

MCard.displayName = 'MCard';
MCard.defaultProps = {};

export default MCard;
